import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationSuggestBlogPostBuilderSectionArgs,
  BackendSuggestBlogPostBuilderContent,
} from 'src/types/backend';

const MUTATION = gql`
  mutation SuggestBlogPostBuilderSection(
    $projectId: ID!
    $sectionId: ID!
    $assetType: AssetTypeEnum!
    $recomposeMode: RecomposeModeEnum
    $continueMode: ContinueModeEnum
    $generationLength: String!
    $keywords: [String!]
    $instruction: Instruction
    $tovInput: TovInput
    $markedSegment: MarkedSegment
    $debugAcPrompt: String
    $freestyleToolAllInstructionsData: JSON
    $url: String
    $urlExtractions: [UrlExtractionInput!]
    $isParagraphMode: Boolean
  ) {
    suggestBlogPostBuilderSection(
      projectId: $projectId
      sectionId: $sectionId
      assetType: $assetType
      recomposeMode: $recomposeMode
      continueMode: $continueMode
      generationLength: $generationLength
      keywords: $keywords
      instruction: $instruction
      tovInput: $tovInput
      markedSegment: $markedSegment
      debugAcPrompt: $debugAcPrompt
      freestyleToolAllInstructionsData: $freestyleToolAllInstructionsData
      url: $url
      urlExtractions: $urlExtractions
      isParagraphMode: $isParagraphMode
    ) {
      copyText
      fullSectionHtml
      keywordsUsage
    }
  }
`;

type Variables = Omit<
  BackendMutationSuggestBlogPostBuilderSectionArgs,
  'promptDocumentId' | 'promptImageId'
>;
type Result = BackendSuggestBlogPostBuilderContent;

export const suggestBlogPostBuilderSection = async (
  { freestyleToolAllInstructionsData, ...rest }: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...rest,
      freestyleToolAllInstructionsData: stringifyIfPresent(freestyleToolAllInstructionsData),
    },
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  const parsedRes = getSingleProp<Result>(response.data);
  return {
    ...parsedRes,
    keywordsUsage: parsedRes?.keywordsUsage ? JSON.parse(parsedRes.keywordsUsage as string) : null,
  };
};
